<style lang="less" scoped>
  .expense-group-container{
    /*position: relative;*/
  }
  .expense-group-table{
    /deep/ .ivu-table-expanded-cell {
      padding: 15px 20px;
    }
  }
</style>
<template>
  <div
    ref="contain"
    class="expense-group-container"
  >
    <div class="line text-center">
      <Button
        v-if="show_add_btn"
        class="margin-r"
        type="primary"
        icon="md-add"
        @click="editExpenseGroup()"
      >
        添加
      </Button>
      <Button
        v-if="show_pay_btn"
        class="margin-r"
        type="primary"
        @click="payBatch"
      >
        批量通过
      </Button>
      <RadioGroup
        v-model="params.search_type"
        class="margin-r"
        type="button"
        @on-change="searchTypeChange"
      >
        <Radio label="pending">
          待我处理
        </Radio>
        <Radio label="related">
          与我相关
        </Radio>
        <Radio label="mine">
          我发起的
        </Radio>
        <Radio
          v-if="cur_customer.is_pl"
          label="team"
        >
          我的团队
        </Radio>
      </RadioGroup>
      <i-input
        v-model="params.search"
        class="margin-r"
        placeholder="输入关键字搜索"
        style="width: 180px"
        @on-enter="doSearch"
      />
      <Ajaxbtn
        ref="searchBtn"
        class="margin-r"
        :url="get_my_expense_groups_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleExpenseGroupData"
        @fail="handleExpenseGroupFail"
      />
    </div>
    <div
      v-if="[0,2,3,7].includes(type)"
      class="line color-error text-center"
    >
      {{ typeStr[type] + desStrObj[type] }}
    </div>
    <Table
      class="expense-group-table"
      size="small"
      :max-height="table_height"
      :columns="expense_group_columns"
      :data="expense_groups"
      :loading="loading"
      :no-data-text="empty_tip"
      @on-select-all="onSelectAll"
      @on-select-all-cancel="onSelectAllCancel"
      @on-select="onSelect"
      @on-select-cancel="onSelectCancel"
    />

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
    <FkModal 
      v-if="type===1"
      ref="editor"
      @success="()=>{

        pageChange(1)
      }"
    />
    <!--     v-if="type!==1" -->
    <ExpenseGroupEdit
      v-if="type!==1"
      ref="editor"
      :type="type"
      role="staff"
      @update="updateExpenseGroup"
    />
  </div>
</template>
<script>
  import Util from '../../libs/util';
  import FlowUtil from '../../libs/flow_util';
  import ExpenseUtil from '../../libs/expense_util';
  import CompanyName from '../company/components/name';
  import TeamName from '../team/components/name';
  import FinBase from '../fin/mixins/fin_base';
  import ExpenseGroupExpand from '../fin/components/expense_group_expand';
  import ExpenseGroupUid from '../fin/components/expense_group_uid';
  import UserFlowBase from '../components/flow/user_flow_base';
  import ExpenseGroupEdit from '../expense_group/components/editor';
  import FkModal from '@/views/mine/components/fk_modal/index.jsx';
  import { ACCOUNT_MANAGEMENT } from '@/views/fin/account_management/constants.js'
  import {FK_BLOG_XX, ZD_BLOG_XX} from './components/fk_modal/constants'
  import { handleUserFlow } from '@/views/components/flow/utils.js'
  import {mapGetters} from "vuex";
  import batch_pay_mixins from '@/views/expense_group/libs/batch_pay_mixins.js'
  
  import { getsafe } from '@/libs/util.js'
  const desStr_other = '请联系【财务付款·Gucci】并由财务统一处理, 无需个人填写'
  const desStr_type_0 = '请在企业微信端填写'
  const desStrObj = {
    0:desStr_type_0,
    3:desStr_other,
    7:desStr_other,
    2:desStr_other,
  }
  const typeStr = {
    0:'报销',
    3:'充值',
    7:'冲销',
    2:'预支'
  }
  export default {
    // eslint-disable-next-line
    components: { ExpenseGroupExpand, ExpenseGroupUid, UserFlowBase, ExpenseGroupEdit,FkModal },
    mixins: [ FinBase, batch_pay_mixins ],
    props: {
      type: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        // get_my_expense_groups_path: Util.api.query_mine_expense,
        get_my_expense_groups_path: Util.api.es_query_mine_expense_group,
        loading: false,
        empty_tip: '获取数据中...',
        params: {
          per_page: 10,
          page: 1,
          search: '',
          team_id: '0',
          company_id: '0',
          payment_type: this.type,
          search_type: 'pending'
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        status_hash: {
          0: '待财务审核',
          5: '财务已审核, 待付款',
          9: '已完成'
        },
        show_editor: false,
        expense_groups: [],
        banks: [],
        banks_hash: {},
        desStrObj,
        typeStr,
        selected_expense_groups: [],
      }
    },
    computed: {
      show_pay_btn() {
        const current_hash = this.$store.state.hash_authority || {}
        return this.type === 1 && current_hash['user_batch_pay']
      },
      table_height() {
        const window_height = this.$store.state.window_height;
        return window_height - 210;
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      title() {
        return ExpenseUtil.getPaymentType(this.type);
      },
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        jobs: 'async/jobs',
        jobs_hash: 'async/jobs_hash',
      }),
      new_expense_group() {
        const expense_group = Util.clone(ExpenseUtil.new_expense_group);
        expense_group.payment_type = this.type;
        return expense_group;
      },
      expense_group_columns() {
        // 0和1需要加这一列
        const columns = [
          {
            type: 'selection',
            align: 'center',
            width: 30,
            show: this.show_pay_btn
          },
          {
            title: '展开',
            type: 'expand',
            align: 'center',
            width: 50,
            render: (h, params) => {
              return h(ExpenseGroupExpand, {
                props: {
                  type: this.type,
                  model_id: params.row && params.row.id,
                }
              })
            }
          },
          {
            title: '编号',
            key: 'uid',
            width: 120,
            render: (h, params) => {
              let arr = []
              const row = params.row;
              const user_flow = row.user_flow
              if ([0, 1, 9, '0', '1', '9'].includes(this.type) && this.params.search_type === 'pending') {
                arr = handleUserFlow({user_flow, current_user_id:this.cur_customer.id, need_handle:true})
              }
              return h(ExpenseGroupUid, {
                props: {
                  expense_group: row,
                  nodeStatus: arr
                }
              });
            }
          },
          {
            title: '名称',
            key: 'name',
            minWidth: 120
          },
          {
            title: '申请人',
            minWidth: 80,
            render: (h, params) => {
              const row = params.row;
              return (
                <div>
                  <CompanyName id={ row.company_id } short style={{display: 'block'}} />
                  <TeamName id={ row.team_id } style={{display: 'block'}} />
                  <CustomerName id={ row.apply_user_id } />
                </div>
              )
            }
          },
          {
            title: '付款对象',
            minWidth: 140,
            align: 'center',
            render: (h, params) => {
              const ret = [params.row.payee_user || params.row.payee_company];
              const is_multi_payee = getsafe(params, 'row.multi_payee', false)
              if (is_multi_payee) {
                ret.push(h('span', {class:'color-error', style:'margin-left:5px'}, '[MV]'))
              }
              return h('div', ret);
            }
          },
          {
            title: `总金额`,
            align: 'right',
            minWidth: 110,
            key: 'total_price',
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', ExpenseUtil.getCurrencySymbol(row.currency) + Util.formatPrice(row.total_price)));
              return h('div', {
                'class': {
                  //  'text-right': true
                }
              }, ret);
            }
          },
          {
            title: '状态',
            minWidth: 125,
            key: 'status',
            render: (h, params) => {
              const row = params.row;
              const user_flow = row.user_flow;
              if (user_flow) {
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                  }
                })
              }
              if (row.del) {
                return <div class="color-error">已废弃</div>;
              }
              if (row.status === 9) {
                return (
                  <div>
                    <span class="color-success">已完成: </span>
                    <span>{ row.finish_user } </span>
                    <span class="color-grey">{ this.$util.formatDate(row.finished_at) }</span>
                  </div>
                )
              } else {
                return <span>-</span>;
              }
            }
          },
        ];
        if ([1, 2, 4].indexOf(this.type) > -1) {
          columns.push({
            title: '操作',
            width: 80,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const items = [];
              const user_flow = row.user_flow;
              if (!row.del &&
                user_flow && 
                user_flow.is_node_user) {
                items.push(h('DropdownItem', {
                  props:{name: 'edit'}
                }, '编辑'));
              }
              items.push(h('DropdownItem', {
                props:{name: 'copy'}
              }, '复制'));
              if (FlowUtil.canEdit(row, this.cur_customer)) {
                items.push(h('DropdownItem', {
                  props:{name: 'delete', divided: true}
                }, '废弃'));
              }
              if (!items.length) {
                return h('div', '-');
              }
              return h('Dropdown', {
                props: {
                  trigger: 'click',
                  placement: 'left'
                },
                on: {
                  'on-click': (event_name) => {
                    this.handleExpenseGroupEvent(event_name, row, params.index);
                  }
                }
              }, [
                h('div', {
                  class: {
                    link: true
                  }
                }, [
                  h('span', '操作'),
                  h('Icon', {
                    props: {
                      type: 'ios-arrow-down'
                    }
                  })
                ]),
                h('DropdownMenu', {
                  slot: 'list'
                }, items)
              ]);
            }
          });
        }
        if (this.type === 0) {
          columns.push({
            title: '操作',
            width: 80,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const items = [];
              // const user_flow = row.user_flow;
              items.push(h('DropdownItem', {
                props:{name: 'edit_0'}
              }, '编辑'));
            
            
              return h('Dropdown', {
                props: {
                  trigger: 'click',
                  placement: 'left'
                },
                on: {
                  'on-click': (event_name) => {
                    switch (event_name) {
                    case 'edit_0':
                      this.editType0(row)
                      break;
                    
                    default:
                      break;
                    }
                  }
                }
              }, [
                h('div', {
                  class: {
                    link: true
                  }
                }, [
                  h('span', '操作'),
                  h('Icon', {
                    props: {
                      type: 'ios-arrow-down'
                    }
                  })
                ]),
                h('DropdownMenu', {
                  slot: 'list'
                }, items)
              ]);
            }
          });
        }
        if ([0, 1].includes(this.type)) {
          const _this = this
          const invoiceColumn = {
            title: '发票状态',
            key: 'uid',
            minWidth: 100,
            align: 'right',
            render(h, { row = {} } = {}) {
              const { invoice_valid, valid_invoice_price, none_invoice_price, none_invoice_tax } = row.invoice_info || {}
              if (row.is_outsource) { // 外包兼职报销不需要发票
                return <span class="color-success">无需提供发票</span>
              }
              if (invoice_valid) { // invoice_valid === true 表示以提供足额的发票
                return <span class="color-success">已提供足额发票</span>
              } else if (Number(valid_invoice_price) === 0) { //
                return <span class="color-error">暂未提供发票</span>
              }
              if (Number(valid_invoice_price) === 0) { //
                return <span class="color-error">暂未提供发票</span>
              }
              return (
                <div>
                  <p>合规发票金额: {valid_invoice_price}</p>
                  <p>无发票金额: {none_invoice_price}</p>
                  <p >{ _this.type === 0 ? '企业需承担额外税额: ' + none_invoice_tax : ''}</p>
                </div>
              )
            }
          }
          columns.splice(5, 0, invoiceColumn)
        }
        return columns.filter(i => {
          return !!i.show || i.show === undefined
        });
      },
      show_add_btn() {
        const { groups = [] } = this.$store.state.cur_customer || {}
        const current_hash = this.$store.state.hash_authority || {}
     
        if (this.type === 2) {
          return false
        }
   
        if ([1, 4, 5, 6].includes(this.type)) {
          return true
        } 

        if (this.type === 0) {
          return current_hash['reimburse_apply']     
        } 
   
        return groups.includes("GROUP_FIN")
      }
    },
    created() {
      //
    },
    mounted() {
      this.init();
      this.doSearch();
    },
    methods: {
      onSelectCancel(selection, row) {
        const index = this.selected_expense_groups.findIndex(expense_group => expense_group.id === row.id)
        this.selected_expense_groups.splice(index, 1)
      },
      onSelect(selection, row) {
        this.selected_expense_groups.push(row)
      },
      onSelectAllCancel(selection) {
        this.selected_expense_groups = selection
      },
      onSelectAll(selection) {
        selection.forEach(row => {
          if (!this.selected_expense_groups.find(expense_group => expense_group.id === row.id)) {
            this.selected_expense_groups.push(row)
          }
        })
      },
      editType0(item) {
        
        if (FlowUtil.canEdit(item, this.cur_customer)) {
        
          this.$refs.editor.edit({id: item.id});
        } else {
          this.$vModal.warning({
            title: '提示',
            content: '当前节点不能编辑！'
          })
        }
      },
      generateFromContract(contract) {
        this.$refs.editor.generateFromContract(contract)
      },
      init() {
        this.checkContractPayment();
        this.checkFK()
        this.checkZD()
        this.checkZDFromAccount()
      },
      checkZDFromAccount() {
        if (this.type !== 9) {
          return
        }
        const params = JSON.parse(localStorage.getItem(ACCOUNT_MANAGEMENT));
        params && this.$refs.editor.generateFromAccount(params)
        localStorage.removeItem(ACCOUNT_MANAGEMENT)
      },
      checkFK() {
        if (this.type !== 1) {
          return 
        }
        const params = JSON.parse(localStorage.getItem(FK_BLOG_XX));
        params && this.$refs.editor.generateFromBlog(params)
        localStorage.removeItem(FK_BLOG_XX)
      },
      checkZD() {
        if (this.type !== 9) {
          return 
        }
        const params = JSON.parse(localStorage.getItem(ZD_BLOG_XX));
        params && this.$refs.editor.generateFromBlog(params)
        localStorage.removeItem(ZD_BLOG_XX)
      },
      checkContractPayment() {
        let contract = JSON.parse(localStorage.getItem('contract_id_fk'));
       
        if (contract) {
          contract.is_out = false
        } else {
          contract = JSON.parse(localStorage.getItem('contract_id_outsource')) ;
          contract && (contract.is_out = true)
        }
        localStorage.removeItem('contract_id_outsource')
        localStorage.removeItem('contract_id_fk')
        if (contract) {
          this.$refs.editor.generateFromContract(contract)
          return 
        }
       
      
        // localStorage.removeItem('contract_id');
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
        this.expense_groups = [];
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.loading = true;
        this.$refs.searchBtn.doAjax(true);
      },
      searchTypeChange() {
        this.doSearch();
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      updateExpenseGroup(expense_group) {
        if (expense_group.user_flow) {
          Util.insertOrUpdateArrayItem(this.expense_groups, expense_group, true);
        } else {
          this.doSearch();
        }
      },
      handleExpenseGroupData(data) {
        this.loading = false;
        this.expense_groups = [];
        data.expense_groups.forEach((expense_group) => {
          this.expense_groups.push(expense_group);
        });
        if (data.expense_groups.length === 0) {
          this.empty_tip = '没有数据!';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleExpenseGroupFail(e) {
        this.loading = false;
        this.$Message.error('获取失败: ' + e);
        console.log(e);
      },
      getCompanyNameById(id) {
        const company = this.companies_hash[id];
        return company ? company.name : '';
      },
      getTeamNameById(id) {
        const team = this.teams_hash[id];
        return team ? team.name : '';
      },
      getTotalInvoicePrice(expense_group) {
        let total = 0;
        expense_group.expenses.forEach((expense) => {
          const invoice_price = expense.invoice_price || 0;
          total = math.eval(total + '+' + invoice_price);
        });
        return total.toFixed(2);
      },
      getTotalPrice(expense_group) {
        let total = 0;
        expense_group.expenses.forEach((expense) => {
          const price = expense.price || 0;
          total = math.eval(total + '+' + price);
        });
        return total.toFixed(2);
      },
      getExpenseTypeName(id) {
        return id ? this.expense_type_hash[id].name : '';
      },
      scanBarcode(expense, key) {
        eventHub.$emit('show-qr-scaner', (data) => {
          expense[key] = data;
        });
      },
      handleExpenseGroupEvent(event_name, expense_group) {
        console.log(event_name);
        switch (event_name) {
        case 'edit':
          this.editExpenseGroup(expense_group);
          break;
        case 'copy':
          this.copyExpenseGroup(expense_group);
          break;
        case 'delete':
          this.deleteExpenseGroup(expense_group);
          break;
        default:
          this.$Message.error('未定义操作!');
          break;
        }
      },
      deleteExpenseGroup(expense_group) {
        let del_reason = '';
        this.$Modal.confirm({
          title: '提示',
          render: (h) => {
            return h('div', [
              h('div', {
                class: {
                  'line': true,
                  'color-error': true
                }
              }, `你确定要废弃 ${expense_group.name} 吗?`),
              h('Input', {
                props: {
                  value: del_reason,
                  type: 'textarea',
                  maxlength: 200,
                  autofocus: true,
                  placeholder: '请输入废弃的原因'
                },
                on: {
                  input: (val) => {
                    del_reason = val;
                  }
                }
              })
            ]);
          },
          onOk: () => {
            if (!del_reason.trim()) {
              this.$Message.error('请输入废弃的原因?');
              setTimeout(() => {
                this.deleteExpenseGroup(expense_group);
              }, 500);
              return;
            }
            this.$util.ajax.post(this.$util.api.delete_expense_group, {
              id: expense_group.id,
              del_reason: del_reason
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                expense_group.del = true;
                this.$Message.success('废弃成功!');
              } else {
                this.$Modal.error({title: '提示', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '提示', content: e.message});
            });
          }
        })
      },
      editExpenseGroup(expense_group) {
        if (this.type === 1 && expense_group && expense_group.user_flow && expense_group.user_flow.is_finish) {
          this.$vModal.warning({
            title: '提示',
            content: '该付款申请已完结，不允许修改！'
          })
          return 
        }
        this.$refs.editor.edit(expense_group);
      },
      copyExpenseGroup(expense_group) {
        this.$refs.editor.copy(expense_group);
      },
    }
  }
</script>
